import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import ImportAssetsButton from "../../AssetsTable/ImportAssetsButton";

const FileUploadButton = ({ disabled, ...props }) => (
  <Button disabled={disabled} component="span" {...props}>
    {props.children}
  </Button>
);

export default function ImportSKUModal({
  open,
  project,
  onClose,
  onAddNewSKU,
  updateReferenceAssets,
}) {
  const [isAddingSKU, setIsAddingSKU] = useState(false);

  const handleImport = () => {
    onClose();
    updateReferenceAssets();
  };

  const handleAddNewSKU = async () => {
    setIsAddingSKU(true);
    try {
      await onAddNewSKU();
      onClose();
    } catch (error) {
      console.error("Error adding SKU:", error);
    } finally {
      setIsAddingSKU(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography fontWeight={500} fontSize={22} align="center" color="textSecondary">
          Import SKUs
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box pt={2}>
          <Typography align="center" mb={1}>
            Use the template below to import SKUs:
          </Typography>
          <Box display="flex" justifyContent="center" mb={3}>
            <Button
              variant="text"
              color="primary"
              href="https://cdn.filestackcontent.com/ZfPmvi82SlWgdxfNlcGN"
              target="_blank"
              sx={{
                textDecoration: "underline",
                fontSize: "18px",
              }}
            >
              Download Import Template
            </Button>
          </Box>
          <Box display="flex" fullWidth justifyContent="flex-end" gap={1}>
            <Button
              variant="outlined"
              onClick={handleAddNewSKU}
              disabled={isAddingSKU}
              startIcon={isAddingSKU ? <CircularProgress size={16} /> : null}
            >
              Add One SKU
            </Button>
            <ImportAssetsButton
              projectId={project.id}
              component={FileUploadButton}
              label="Import"
              variant="contained"
              handleMenuClose={handleImport}
              assetType="Sku"
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
